import { render, staticRenderFns } from "./summary-passenger-row.vue?vue&type=template&id=0e98d595"
import script from "./summary-passenger-row.vue?vue&type=script&lang=js"
export * from "./summary-passenger-row.vue?vue&type=script&lang=js"
import style0 from "./summary-passenger-row.vue?vue&type=style&index=0&id=0e98d595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports